import { render, staticRenderFns } from "./UnCollectMoney.vue?vue&type=template&id=0159a590&scoped=true&"
import script from "./UnCollectMoney.vue?vue&type=script&lang=js&"
export * from "./UnCollectMoney.vue?vue&type=script&lang=js&"
import style0 from "./UnCollectMoney.vue?vue&type=style&index=0&id=0159a590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0159a590",
  null
  
)

export default component.exports